module.exports = __webpack_public_path__ + "static/media/ic_robot.170c3502.png";